module.exports = __webpack_public_path__ + "img/electric-meter_1.2414e536.svg";